import { useState } from 'react'
import { useNavigate, Link } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'
import toast from 'react-hot-toast'

const USERS = [
  { id: 'andrew', label: 'Andrew' },
  { id: 'sara', label: 'Sara' },
  { id: 'devin', label: 'Devin' },
]

export default function LoginPage() {
  const { loginWithPasskey, loginWithPassword } = useAuth()
  const navigate = useNavigate()
  const [selectedUser, setSelectedUser] = useState(null)
  const [showPassword, setShowPassword] = useState(false)
  const [password, setPassword] = useState('')
  const [loading, setLoading] = useState(false)

  async function handlePasskeyLogin() {
    setLoading(true)
    try {
      await loginWithPasskey(selectedUser)
      navigate('/calendar')
    } catch (err) {
      if (err.name === 'NotAllowedError') {
        toast.error('Face ID was cancelled')
      } else {
        toast.error(err.message || 'Passkey login failed')
        setShowPassword(true)
      }
    } finally {
      setLoading(false)
    }
  }

  async function handlePasswordLogin(e) {
    e.preventDefault()
    if (!password) return
    setLoading(true)
    try {
      await loginWithPassword(selectedUser, password)
      navigate('/calendar')
    } catch (err) {
      toast.error(err.message || 'Login failed')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="min-h-screen bg-gradient-to-b from-green-50 to-white flex flex-col items-center justify-center p-6">
      <div className="w-full max-w-sm">
        <div className="text-center mb-8">
          <div className="text-5xl mb-3">🍴</div>
          <h1 className="text-2xl font-bold text-gray-900">Dinner Planner</h1>
          <p className="text-gray-500 mt-1">Maksimovich Family</p>
        </div>

        {!selectedUser ? (
          <div className="card p-6">
            <p className="text-sm text-gray-600 mb-4 text-center">Who's signing in?</p>
            <div className="flex flex-col gap-3">
              {USERS.map(u => (
                <button
                  key={u.id}
                  onClick={() => setSelectedUser(u.id)}
                  className="w-full py-3 px-4 rounded-xl border-2 border-gray-200 hover:border-green-400 hover:bg-green-50 font-medium text-gray-800 transition-colors text-left"
                >
                  {u.label}
                </button>
              ))}
            </div>
          </div>
        ) : (
          <div className="card p-6">
            <button
              onClick={() => { setSelectedUser(null); setShowPassword(false); setPassword('') }}
              className="text-sm text-gray-400 hover:text-gray-600 mb-4 flex items-center gap-1"
            >
              ← Back
            </button>

            <p className="text-center font-medium text-gray-900 mb-6">
              Sign in as {USERS.find(u => u.id === selectedUser)?.label}
            </p>

            {!showPassword ? (
              <div className="flex flex-col gap-3">
                <button
                  onClick={handlePasskeyLogin}
                  disabled={loading}
                  className="btn-primary w-full py-3 flex items-center justify-center gap-2 text-base"
                >
                  {loading ? (
                    <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white" />
                  ) : (
                    <>
                      <span>🔑</span> Sign in with Face ID
                    </>
                  )}
                </button>
                <button
                  onClick={() => setShowPassword(true)}
                  className="text-sm text-gray-400 hover:text-gray-600 text-center"
                >
                  Use password instead
                </button>
              </div>
            ) : (
              <form onSubmit={handlePasswordLogin} className="flex flex-col gap-3">
                <input
                  type="password"
                  value={password}
                  onChange={e => setPassword(e.target.value)}
                  placeholder="Password"
                  autoFocus
                  className="w-full border border-gray-300 rounded-lg px-4 py-3 text-base focus:outline-none focus:ring-2 focus:ring-green-500"
                />
                <button
                  type="submit"
                  disabled={loading || !password}
                  className="btn-primary w-full py-3 text-base"
                >
                  {loading ? 'Signing in…' : 'Sign in'}
                </button>
                <button
                  type="button"
                  onClick={() => setShowPassword(false)}
                  className="text-sm text-gray-400 hover:text-gray-600 text-center"
                >
                  Try Face ID instead
                </button>
              </form>
            )}
          </div>
        )}
      </div>

      <p className="mt-8 text-center">
        <Link to="/privacy" className="text-xs text-gray-300 hover:text-gray-400">Privacy Policy</Link>
      </p>
    </div>
  )
}
